export default "__VITE_ASSET__Tug_8dI3__"